// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"f118cac1","216":"69801100","263":"a998c7d2","314":"78636828","401":"73cf474d","453":"08406e0f","497":"80d65d0b","533":"2ed819a1","559":"3c0abb72","570":"9b1a9633","616":"3527a88a","712":"5bacc26d","842":"e02f3fd1","845":"2eebca56","978":"24d59ecd"}[chunkId] + ".chunk.js";
};